import { getPath, pageNames } from '@atc/bonnet-paths';
const {
  VEHICLE_DETAILS
} = pageNames;

// eslint-disable-next-line no-return-await
const buildVdpUrl = async function () {
  let listingId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return await getPath(VEHICLE_DETAILS, {
    listingId
  }, {
    absolute: true
  });
};
export { buildVdpUrl as default };
